import {Component, Input} from '@angular/core';
import {MarkantElementsModule} from '@markant/elements-angular';
import Required from '@util/decorators/required';
import {Router} from '@angular/router';
import {RouteBuilder} from '@util/route-builder';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkantElementsModule],
})
export class HeaderComponent {
  @Required @Input() title: string;
  @Input() small: boolean;
  @Input() alignLeft: boolean = false;

  constructor(private readonly router: Router) {}

  checkLogo() {
    return this.router.url.includes(RouteBuilder.signup().build());
  }
}
